// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snowball-box {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.snowflakes-box {
  position: fixed;
  top: 0;
  z-index: 10;
}

.snowflakes-box .snowflake {
  position: absolute;
  border-radius: 50%;
  color: #a6e7ff;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Snow/Snow.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AACF","sourcesContent":[".snowball-box {\n  pointer-events: none;\n  user-select: none;\n}\n\n.snowflakes-box {\n  position: fixed;\n  top: 0;\n  z-index: 10;\n}\n\n.snowflakes-box .snowflake {\n  position: absolute;\n  border-radius: 50%;\n  color: #a6e7ff;\n  pointer-events: none;\n  user-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
